import debug from "debug";
import * as THREE from "three";
import {
    partsTableUrl,
    pnUrl,
    ffUrl,
    assetURL,
  } from "../../../Experience/World/config";

const log = debug("app:globalTable");

class GlobalTablePartPlacement {
    private experience: any;
    private camera: THREE.PerspectiveCamera;
    private controls: any;
    private scene: THREE.Scene;
    private eventHub: any;

    constructor(experience: any) {
        this.experience = experience;
        this.camera = experience.camera.instance;
        this.controls = experience.camera.controls;
        this.scene = experience.scene;
        this.eventHub = this.experience.eventHub;

        // Listen for part placement requests
        this.eventHub.on("placePartTopRight", (rowData: any) => this.handlePlacePart(rowData));
    }

    /**
     * Handles part placement when a row is clicked.
     * Fetches part details and positions the part at the top-right of the frustum.
     */
    private async handlePlacePart(rowData: any) {
        const pnValue = rowData[0]; // Get part number
        const urlForPn = `${pnUrl}/${pnValue}`;

        try {
            const response = await fetch(urlForPn);
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const data = await response.json();

            const partProperties = {
                "Part Number": data.id,
                Manufacturer: data.mfgCode,
                "Manufacturer Part Number": data.mfgPart,
                ...Object.fromEntries(data.props.map((prop: any) => [prop.label, prop.value])),
                FormFactor: data.ffId
            };

            const urlForFfid = `${ffUrl}/${data.ffId}`;
            const ffResponse = await fetch(urlForFfid);
            if (!ffResponse.ok) throw new Error(`HTTP error! Status: ${ffResponse.status}`);
            const ffData = await ffResponse.json();

            // Get top-right position in world coordinates
            const topRight = this.getTopRightFrustum();

            // Create part data object
            const xmd = {
                partData: {
                    fullpartnumber: pnValue,
                    layer: data.layer,
                    properties: partProperties,
                },
                x: topRight.x,  // Correct left-right placement
                y: topRight.y,  // Correct in-out placement
                z: topRight.z,  // Correct up-down placement
                angle: 0,
            };

            // Emit event to create the part in Three.js
            this.eventHub.emit("MakePartsEvent", {
                eventType: "add",
                data: { figures: [xmd] },
            });

            log(`Placed part ${pnValue} at top-right:`, topRight);
        } catch (error) {
            console.error("Error fetching part data:", error);
        }

        
    }

    /**
     * Gets the world position of the top-right corner of the frustum.
     */
    private getTopRightFrustum(): { x: number; y: number; z: number } {
        if (!this.camera) {
            console.error("Camera is not defined!");
            return { x: 0, y: 0, z: 0 };
        }
    
        const ndcCoords = new THREE.Vector3(1, 1, -1); // Top-right in NDC space
        ndcCoords.unproject(this.camera); // Convert NDC to world coordinates
    
        // Offset slightly towards the center (adjust values as needed)
        const offsetFactor = 0.35; // Move slightly inward
        ndcCoords.x -= (ndcCoords.x - this.camera.position.x) * offsetFactor;
        ndcCoords.y -= (ndcCoords.y - this.camera.position.y) * offsetFactor;
        ndcCoords.z -= (ndcCoords.z - this.camera.position.z) * offsetFactor;
    
        // ✅ Round the coordinates to the nearest integer
        return {
            x: Math.round(ndcCoords.x),
            y: Math.round(ndcCoords.y),
            z: Math.round(ndcCoords.z),
        };
    }
    
    
    
    
    
}

export default GlobalTablePartPlacement;
